import { render, staticRenderFns } from "./CheckExample.vue?vue&type=template&id=f2186a92&scoped=true"
import script from "./CheckExample.vue?vue&type=script&lang=js"
export * from "./CheckExample.vue?vue&type=script&lang=js"
import style0 from "./CheckExample.vue?vue&type=style&index=0&id=f2186a92&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2186a92",
  null
  
)

export default component.exports